/**
 * Helpers for using local storage as cache with simple expiry & size handling
 *
 * @param {string} key Cache key. Keys should be prefixed by a namespace followed by '/', e.g. app_name/cache_key_name
 * @param {*} value Cache value
 * @param {number} expires Cache expiry time in seconds past epoch
 */
export const cache = (key, value, expires = null, cacheStore = window.localStorage) => {
  if (!cacheStore) return null;
  let prefix, prefixResult;

  if ((prefixResult = /^(\w+)\//.exec(key))) {
    prefix = prefixResult[1];
  } else {
    // set a default prefix if none given to support clearing a full cache
    prefix = 'wcl/';
    key = prefix + key;
  }
  const cachedValue = { value };

  if (expires) {
    cachedValue.expires = Math.floor(Date.now() / 1000) + expires;
  }

  try {
    cacheStore.setItem(key, JSON.stringify(cachedValue));
  } catch (error) {
    // failure likely to be due to a full cache - clear cache entries with same key prefix
    Object.keys({ ...cacheStore }).forEach(item => {
      const itemRegex = new RegExp(`^${prefix}/`);
      if (itemRegex.test(item)) {
        cacheStore.removeItem(item);
      }
    });
  }
};

export const sessionCache = (key, value, expires = null) => cache(key, value, expires, window.sessionStorage);

/**
 * @param {string} key Cache key
 * @returns {*} Cached value if key exists and not expired, otherwise null.
 */
export const cached = (key, cacheStore = window.localStorage) => {
  if (!cacheStore) return null;
  let cachedValue;

  if ((cachedValue = cacheStore.getItem(key))) {
    cachedValue = JSON.parse(cachedValue);
    if (!cachedValue.hasOwnProperty('expires') || cachedValue.expires > Math.floor(Date.now() / 1000)) {
      return cachedValue.value;
    } else {
      // remove expired entry
      cacheStore.removeItem(key);
    }
  }

  return null;
};

export const sessionCached = key => cached(key, window.sessionStorage);
